/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maximum10filesallowed2Inputs */

const en_maximum10filesallowed2 = /** @type {(inputs: Maximum10filesallowed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum 10 files allowed`)
};

const de_maximum10filesallowed2 = /** @type {(inputs: Maximum10filesallowed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximal 10 Dateien zulässig`)
};

/**
* | output |
* | --- |
* | "Maximum 10 files allowed" |
*
* @param {Maximum10filesallowed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const maximum10filesallowed2 = /** @type {((inputs?: Maximum10filesallowed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maximum10filesallowed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_maximum10filesallowed2(inputs)
	return de_maximum10filesallowed2(inputs)
});
export { maximum10filesallowed2 as "maximum10FilesAllowed" }